// extracted by mini-css-extract-plugin
module.exports = {"container":"_2GFOq8WbxCe6O-Hn29Vkp5"};